import api from "./api";

const appointmentService = {};
const endpoint = "/appointments";

appointmentService.createAppointment = function (appointment) {
  return api.post(endpoint, appointment).then(({ data }) => data);
};

appointmentService.getAppointmentById = function ({ id, params }) {
  return api.get(`${endpoint}/${id}`, { params }).then(({ data }) => data);
};

appointmentService.getAppointmentsByPatient = function ({
  patientId,
  params = { sort: { startsAt: -1 } },
}) {
  return api
    .get(`${endpoint}/patient/${patientId}`, { params })
    .then(({ data }) => data);
};

appointmentService.getAppointments = function ({ params }) {
  return api.get(endpoint, { params }).then(({ data }) => data);
};

appointmentService.cancelAppointment = function (id) {
  return api.delete(`${endpoint}/${id}`).then(({ data }) => data);
};

const getErrorMessage = (err) => {
  const status = err.response?.status;
  const appointment = err.response?.data?.appointment;

  if (status === 409 && appointment) {
    if (appointment.status === "pending") {
      return "El paciente debe ser admitido para iniciar la consulta.";
    }
    if (appointment.status === "done") {
      return "Esta atención tiene un estado de finalizada.";
    }
    if (appointment.status === "cancelled") {
      return "Esta atención tiene un estado de cancelada.";
    }
  }

  return "No se puede iniciar la atención.";
};

appointmentService.startAppointment = function (id) {
  return api
    .put(`${endpoint}/${id}/start`, {}, { getErrorMessage })
    .then(({ data }) => data);
};

appointmentService.endAppointment = function (id) {
  return api.put(`${endpoint}/${id}/end`).then(({ data }) => data);
};

appointmentService.admitAppointment = function (id) {
  return api
    .put(`${endpoint}/${id}/admit`, {}, { getErrorMessage })
    .then(({ data }) => data);
};

appointmentService.updateObservation = function (id, observation) {
  return api
    .put(`${endpoint}/${id}/observation`, { observation })
    .then(({ data }) => data);
};

const getCallErrorMessage = (err) => {
  const statusCode = err.response?.status;
  const errorCode = err.response?.data?.error;

  if (statusCode === 403) {
    return "La funcionalidad de llamadas no está habilitada para su organización.";
  }

  if (statusCode === 400) {
    if (
      errorCode === "CallProviderTypeMissing" ||
      errorCode === "CallProviderConfigMissing" ||
      errorCode === "CallProviderTypeEmpty" ||
      errorCode === "CallProviderApiKeyMissing" ||
      errorCode === "CallProviderUrlMissing"
    ) {
      return "La configuración del proveedor de llamadas no está completa. Contacte al administrador.";
    }

    if (errorCode === "DoctorBoxNotSelected") {
      return "No tiene ningún box seleccionado. Por favor seleccione uno e intente de nuevo.";
    }
  }

  if (statusCode === 404) {
    return "No se encontró la atención solicitada.";
  }

  return "Error al enviar la llamada. Por favor, intente nuevamente.";
};

appointmentService.getAppointmentsByDoctor = function ({ doctorId, params }) {
  return api
    .get(`${endpoint}/doctor/${doctorId}`, { params })
    .then(({ data }) => data);
};

appointmentService.callPatient = function (id) {
  return api
    .post(
      `${endpoint}/${id}/call`,
      {},
      { getErrorMessage: getCallErrorMessage }
    )
    .then(({ data }) => data);
};

export default appointmentService;
